(function ($) {
    'use strict';


    var canvas_width = cmToPixel(100),
        canvas_height = cmToPixel(100),
        uniqId = fabric.Object.__uid;

    const fontFamilySelect = document.getElementById('fontFamilySelect');
    const textSizeInput = document.getElementById('textSizeInput');
    const textColorInput = document.getElementById('bgColorPicker');
    const boldCheckbox = document.getElementById('boldCheckbox');
    const italicCheckbox = document.getElementById('italicCheckbox');
    const underlineCheckbox = document.getElementById('underlineCheckbox');
    const optionMenu = document.querySelector(".select-menu"),
      selectBtn = optionMenu.querySelector(".select-btn"),
      options = optionMenu.querySelectorAll(".option"),
      sBtn_text = optionMenu.querySelector(".sBtn-text");
    var scaleXdata = "";
    var scaleYdata = "";

    var bgImage = "";

    var canvas = new fabric.Canvas("bg_canvas", {
        left: cmToPixel(2),
        top: cmToPixel(2),
        preserveObjectStacking: true,
        uniformScaling: true,
        uniScaleTransform: true,
        enableRetinaScaling: false
    });
    // canvas.uniformScaling = false;

    canvas.setWidth(canvas_width).setHeight(canvas_height);
    addRulers(canvas_width, canvas_height);

    let holderHeightTmp = $('.bg-canvas-holder').outerWidth();
    var holderHeight = holderHeightTmp;
    $('.bg-canvas-holder').css('height', holderHeight + 'px');

    $(window).on('resize', function () {
        let holderHeightTmp = $('.bg-canvas-holder').outerWidth();
        var holderHeight = holderHeightTmp;
        $('.bg-canvas-holder').css('height', holderHeight + 'px');

        var cmDataNew = 100;
        var cmDataNewPixel = cmToPixel(cmDataNew);
        resetCanvasSize(canvas, { 'width': cmDataNewPixel, 'height': cmDataNewPixel });
    });

    canvas.on('object:added', function (currentObj) {
        removeObjectControls(currentObj.target);
        // updateModifications();
    });
    canvas.on('object:modified', function (currentObj) {
        // updateModifications();
    });

    // Restrict objects from moving outside the canvas
    canvas.on('object:moving', function (e) {
        var obj = e.target;
        // if object is too big ignore
        if (obj.currentHeight > obj.canvas.height || obj.currentWidth > obj.canvas.width) {
            return;
        }
        obj.setCoords();
        // top-left  corner
        if (obj.getBoundingRect().top < 0 || obj.getBoundingRect().left < 0) {
            var topVal = Math.max(obj.top, obj.top - obj.getBoundingRect().top);
            var leftVal = Math.max(obj.left, obj.left - obj.getBoundingRect().left);
            obj.top = (topVal < 0) ? 1 : topVal;
            obj.left = (leftVal < 0) ? 1 : leftVal;
        }
        var boundingRect = obj.getBoundingRect();
        var realSizeData = calculateRealSize(canvas);
        var canHeight = cmToPixel(realSizeData.height);
        var canWidth = cmToPixel(realSizeData.width);

        if (boundingRect.left + boundingRect.width > canvas.width) {
            if (obj.scaleX != 1) {
                obj.left = (canWidth - (obj.width * obj.scaleX)) - 1;
            } else {
                var leftData = (canvas.width - boundingRect.width + ((obj.left * obj.zoomX) - boundingRect.left)) / obj.zoomX;
                obj.left = leftData - 1;
            }
        }

        if (boundingRect.top + boundingRect.height > canvas.height) {
            if (obj.scaleY != 1) {
                obj.top = (canHeight - (obj.height  * obj.scaleY)) - 1;
            } else {
                var topData = (canvas.height - boundingRect.height + ((obj.top * obj.zoomY) - boundingRect.top)) / obj.zoomY;
                obj.top = topData - 1;
            }
        }
    });

    // Restrict objects from enlarge more than canvas
    var left1 = 0;
    var top1 = 0;
    var scale1x = 0;
    var scale1y = 0;
    var width1 = 0;
    var height1 = 0;
    var textSizeData = "";
    let previousScaleY = null;
    canvas.on('object:scaling', function (e) {
        var obj = e.target;

        // if (previousScaleY !== null && obj.scaleY !== previousScaleY && obj.type == "i-text") {
        //     scaleYdata = "";
        // }

        var maxPx = cmToPixel(100);
        const boundingRect = obj.getBoundingRect();

        const viewportTransform = canvas.viewportTransform;
        const scaleFactor = viewportTransform[0]; // Assuming uniform scaling

        const maxSize = maxPx * scaleFactor;
        let newScaleX = obj.scaleX;
        let newScaleY = obj.scaleY;

        var widthData = (obj.width * newScaleX) * scaleFactor;
        var heightData = (obj.height * newScaleY) * scaleFactor;

        if (widthData >= maxSize && scaleXdata == "") {
            newScaleX = (maxSize / obj.width) / scaleFactor;
            if (scaleYdata == '') {
                scaleYdata = obj.scaleY; // lock height
            }
        } else {
            scaleYdata = "";
        }

        if (heightData >= maxSize && scaleYdata == "") {
            newScaleY = (maxSize / obj.height) / scaleFactor;
            if (scaleXdata == '') {
                scaleXdata = obj.scaleX; // lock height
            }
        } else {
            scaleXdata = "";
        }

        if (scaleYdata) {
            newScaleY = scaleYdata;
        }
        if (scaleXdata) {
            newScaleX = scaleXdata;
        }

        obj.set({
            scaleX: newScaleX,
            scaleY: newScaleY,
        });
        previousScaleY = obj.scaleY;
        // obj.setCoords();
    });
    
    canvas.on('object:scaling', function (e) {
        var obj = e.target;
        obj.setCoords();
        var brNew = obj.getBoundingRect();

        if (((brNew.width + brNew.left) >= obj.canvas.width) || ((brNew.height + brNew.top) >= obj.canvas.height) || ((brNew.left < 0) || (brNew.top < 0))) {
            textSizeInput.value = textSizeData;
            if (obj.type == "i-text") {
                obj.set({
                    fontSize: textSizeData
                });
            }
            obj.left = left1;
            obj.top = top1;
            obj.scaleX = scale1x;
            obj.scaleY = scale1y;
            obj.width = width1;
            obj.height = height1;
        } else {
            textSizeData = textSizeInput.value;
            left1 = obj.left;
            top1 = obj.top;
            scale1x = obj.scaleX;
            scale1y = obj.scaleY;
            width1 = obj.width;
            height1 = obj.height;
        }
    });

    function removeObjectControls(obj) {
        if (obj.type == "i-text") {
            obj.setControlsVisibility({
                mtr: false,
                ml: false,
                mt: false,
                mr: false,
                mb: false,
                bl: false,
                br: false,
                tl: false,
                tr: false
            });
        } else {
            obj.setControlsVisibility({
                mtr: false,
                ml: false,
                mt: false,
                mr: false,
                mb: false,
                bl: false,
                br: false,
                tl: false,
                tr: false
            });
        }
    }

    // update height width based on input
    /* var previousSizeValue = $("#canvasheightandwidth").val();
    $("#canvasheightandwidth").on('change', function () {
        var currentValue = $(this).val();
        if (currentValue !== previousSizeValue && previousSizeValue !== "") {
            if (canvas.getObjects().length > 0) {
                // Show the confirmation modal
                $('#clearCanvasModal').modal('show');
            } else {
                changeCanvasSize(currentValue);
                previousSizeValue = currentValue;
            }
        } else {
            changeCanvasSize(currentValue);
            previousSizeValue = currentValue;
        }
    }); */

    // Event listener for confirming canvas clearing
    /* $('#clearCanvasConfirm').on('click', function () {
        // Clear the canvas
        canvas.clear();

        // Close the modal
        $('#clearCanvasModal').modal('hide');
    });

    // Event listener for canceling canvas clearing
    $('#cancelClearCanvas').on('click', function () {
        console.log(previousSizeValue);
        // Revert dropdown to its old value
        $('#canvasheightandwidth').val(previousSizeValue);
    }); */
    /* function changeCanvasSize(sizeData) {
        var cmData = 50;
        var cmDataPixel = 0;
        var canvasHeightWidthVal = sizeData;
        if (canvasHeightWidthVal) {
            if (canvasHeightWidthVal == 2) {
                cmData = 100;
            } else if (canvasHeightWidthVal == 4) {
                cmData = 200;
            }
            cmDataPixel = cmToPixel(cmData);
        } else {
            cmDataPixel = cmToPixel(cmData);
        }
        resetCanvasSize(canvas, { 'width': cmDataPixel, 'height': cmDataPixel });
        // canvas.setWidth(cmDataPixel).setHeight(cmDataPixel);
        // addRulers(cmDataPixel, cmDataPixel);

        if (canvasHeightWidthVal == 2) {
            // setTypeTowSize();
            // textSizeInput.value = 150;
            $('.for200').hide();
            $('.for100').show();
        } else if (canvasHeightWidthVal == 4) {
            // setTypeThreeSize();
            // textSizeInput.value = 350;
            $('.for100').hide();
            $('.for200').show();
        } else {
            // setDefaultSize();
            textSizeInput.value = 50;
        }
        resetUndoRedo();
        zoomTo(1);
    } */

    function renderIcon(icon) {
        return function renderIcon(ctx, left, top, styleOverride, fabricObject) {
            var size = this.cornerSize;
            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(icon, -size / 2, -size / 2);
            ctx.restore();
        }
    }

    /*$("#bgImageUpload").on('change', function () {
       // console.log($(this));
        const inputElement = $(this)[0]; // Get the DOM element
        const files = inputElement.files; // Access files property using the DOM element

        if (files.length > 0) { // Check if files were selected
            const fileReader = new FileReader();
            fileReader.readAsDataURL(files[0]); // Read the first file

            fileReader.addEventListener("load", function () {
                set_canvas_bg(this.result);
                bgImage = this.result;
            });
        }
        $(this).val("");
    });*/

   /* $("#bg-image-upload-button").on('click', function () {
        $("#bgImageUpload").trigger('click');
    });*/

    const mypopup = document.getElementById("mypopup");
    const mypopupcloseBtn = document.querySelector(".mypopupclose");

    // mypopupClose the mypopup when the 'x' is clicked
    mypopupcloseBtn.onclick = function() {
        mypopup.style.display = "none";
    };

    // mypopupClose the mypopup when clicking outside the mypopup content
    window.onclick = function(event) {
        if (event.target === mypopup) {
            mypopup.style.display = "none";
        }
    };

    $("#single-image-upload-button").on('click', function () {
        if($(this).hasClass('cron-warned')) {
            sizeValidation(true);    
        } else {
            mypopup.style.display = "flex";
            $(this).addClass('cron-warned');
        }         
    });

    $("#uploadPhotoBtn").on('click', function () {
        sizeValidation(true);
        mypopup.style.display = "none";
    });

    function calculateRealSize(canvas, dpi = 96) {
        // Get the current dimensions of the canvas in pixels
        const canvasWidth = canvas.getWidth();
        const canvasHeight = canvas.getHeight();

        // Get the scaling factor applied to the canvas
        const scale = canvas.viewportTransform[0];

        // Calculate the real size in pixels
        const realWidthInPixels = canvasWidth / scale;
        const realHeightInPixels = canvasHeight / scale;

        // Convert pixels to inches (1 inch = dpi pixels)
        const realWidthInInches = realWidthInPixels / dpi;
        const realHeightInInches = realHeightInPixels / dpi;

        // Convert inches to centimeters (1 inch = 2.54 cm)
        const realWidthInCm = realWidthInInches * 2.54;
        const realHeightInCm = realHeightInInches * 2.54;
        return {
            width: realWidthInCm.toFixed(0),
            height: realHeightInCm.toFixed(0)
        };
    }


    function sizeValidation(imgUpload = false) {
        var retData = true;
        var alertContent = "";
        var currentSize = 2;
        var canvasImagesCount = canvas.getObjects('image').length;
        var maxImagesAllowed = { 1: 0, 2: 0, 4: 3 };
        var requiredCanvasSizes = {
            1: { width: 50, height: 50 },
            2: { width: 100, height: 100 },
            4: { width: 200, height: 200 }
        };

        var realSizeData = calculateRealSize(canvas);
        var canvasWidthInCm = realSizeData.width;//pixelsToCentimeters(canvas.width);
        var canvasHeightInCm = realSizeData.height;//pixelsToCentimeters(canvas.height);
        if (requiredCanvasSizes[currentSize]) {
            var requiredWidth = requiredCanvasSizes[currentSize].width;
            var requiredHeight = requiredCanvasSizes[currentSize].height;
           
            if (canvasWidthInCm == requiredWidth && canvasHeightInCm == requiredHeight &&
                canvasImagesCount <= maxImagesAllowed[currentSize]) {
               
                if (imgUpload) {
                    $("#singleImageUpload").trigger('click');
                } else {
                    return retData;
                }
            } else {
                if (canvasWidthInCm != requiredWidth || canvasHeightInCm != requiredHeight) {
                    alertContent = `${alertmsg3half} ${requiredWidth}x${requiredHeight} ${alertmsg3half2}`;
                    $('.size-alert-modal .modal-body').text(alertContent);
                    $('#sizeAlertModal').modal('show');
                    retData = false;
                    return retData;
                } else {
                    alertContent = `${alertmsg4_1}`;
                    $('.size-alert-modal .modal-body').text(alertContent);
                    $('#sizeAlertModal').modal('show');
                    retData = false;
                    return retData;
                }
            }
        } else {
            alertContent = alertmsg1;
            $('.size-alert-modal .modal-body').text(alertContent);
            $('#sizeAlertModal').modal('show');
            retData = false;
            return retData;
        }
    }

    $("#singleImageUpload").on('change', function () {
        const inputElement = $(this)[0]; // Get the DOM element
        var file = inputElement.files[0];
        if (file) { // Check if files were selected
            $('.bg-loader .bg-loader-btn span').text("Removing your background, please wait...");
            $('.bg-loader').show();
            var formData = new FormData();
            formData.append('image', file);
            $.ajax({
                url: 'https://inspirewallsticker.photos/removebgapi.php',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (response.error) {
                        var bgError = response.error;
                        $('.size-alert-modal .modal-body').text(bgError);
                        $('#sizeAlertModal').modal('show');
                    } else {
                        var base64Data = `data:${response.mime_type};base64,${response.image}`;
                        canvas_add_image(base64Data);
                    }
                    $('.bg-loader').hide();
                    $('.bg-loader .bg-loader-btn span').text("Processing...");
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    var bgError = 'Server error: ' + textStatus;
                    $('.size-alert-modal .modal-body').text(bgError);
                    $('#sizeAlertModal').modal('show');
                    $('.bg-loader').hide();
                    $('.bg-loader .bg-loader-btn span').text("Processing...");
                }
            }); 
        }
        $(this).val("");
    });

    $(document).on('click', '.canvas_remove_image', function (e) {
        e.preventDefault();
        var index = $(this).parent().index();
        //$('#recentUploadConfirm').attr('data-index', index);
       // $('#recentUploadModal').modal('show');
    });

    /*$(document).on('click', '#recentUploadConfirm', function (e) {
        var curIndex = $(this).attr('data-index');
        $('.recent-upload').children().eq(curIndex).remove();
        $('#recentUploadModal').modal('hide');
        $(this).attr('data-index', '');
        if (jQuery('.imglist-item').length > 3) {
            $('.recent-upload-prev').show();
            $('.recent-upload-next').show();
            $(".recent-upload").css('left', "10px");
        } else {
            $('.recent-upload-prev').hide();
            $('.recent-upload-next').hide();
            $(".recent-upload").css('left', "0px");
        }
        if (jQuery('.imglist-item').length <= 0) {
            $('.recent-upload-container').hide();
        }
    });*/

    /*$(document).on('click', '.canvas_add_replace_image', function (e) {
        e.preventDefault();
        var url = $(this).data('url');
        if (canvas.getActiveObject() && 'image' == canvas.getActiveObject().type) {
            var j = new Image();
            j.src = url;
            j.onload = function () {
                console.log(canvas.getActiveObject().width);
                var p = new fabric.Image(j);
                var m = j.width;
                var l = canvas.getActiveObject().width;
                var n = 1;
                var w = canvas.getActiveObject().width;
                var h = canvas.getActiveObject().height;
                if (j.width > w || j.height > h) {
                    j.width > j.height ? m = j.width : m = j.height;
                    w > h ? l = w : l = h;
                    n = l / m;
                }
                p.scale(n);
                p.orig_src = j.src;
                p.left = canvas.getActiveObject().left;
                p.top = canvas.getActiveObject().top;
                p.angle = canvas.getActiveObject().angle;
                p.opacity = canvas.getActiveObject().opacity;
                //p.crossOrigin="Anonymous"
                canvas.insertAt(p, canvas.getObjects().indexOf(canvas.getActiveObject()));
                canvas.remove(canvas.getActiveObject());
                canvas.setActiveObject(p);
                canvas.renderAll();
            }
            return;
        }
        var sizeValidationData = sizeValidation();
        if (sizeValidationData) {
            canvas_add_image(url, 0, 0, false);
        }
    });*/

    $(document).on('click', '.sample-bg-image', function (e) {
        var imgSrc = $(this).find('img').attr('src');
        set_canvas_bg(imgSrc);
    });

    // set_canvas_bg(a)
    let bgData = "";

    function set_canvas_bg(a) {
        fabric.Image.fromURL(a, function (b) {
            b.set({
                originX: "left",
                originY: "top"
            });
            var c = parseInt(canvas.width) / parseInt(b.getScaledWidth());
            b.scale(c);
            if (canvas.getHeight() > b.getScaledHeight()) {
                b.scaleToHeight(canvas.getHeight())
            }
            b.left = (canvas.getWidth() - b.getScaledWidth()) / 2;
            b.top = (canvas.getHeight() - b.getScaledHeight()) / 2;
            canvas.setBackgroundImage(b, canvas.renderAll.bind(canvas));
            bgData = b;
        })
    }

    // function canvas_add_image(b, a = 0, g = 0, recentUpload = true) {
    //     var j = new Image();
    //     j.src = b;
    //     j.onload = function () {
    //         var p = new fabric.Image(j);
    //         var m = j.width;
    //         var l = canvas.width;
    //         var n = 1;
    //         var targetWidth = l / 2;
    //         var n = targetWidth / m;
    //         // if (j.width > canvas.width || j.height > canvas.height) {
    //         //     j.width > j.height ? m = j.width : m = j.height;
    //         //     canvas.width > canvas.height ? l = canvas.width : l = canvas.height;
    //         //     n = l / m / 2
    //         // }
    //         p.scale(n);
    //         p.left = 0;
    //         var images = canvas.getObjects('image');
    //         if (images.length > 0) {
    //             var canvasWidth = canvas.getWidth() / canvas.viewportTransform[0];
    //             // Set the new image's position to top right
    //             p.left = canvasWidth - (p.getScaledWidth() / canvas.viewportTransform[0]);
    //         }
    //         p.top = 0;
    //         p.orig_src = j.src;
    //         p.uniqId = uniqId++;
    //         p.crossOrigin = 'anonymous';
    //         // canvas.centerObject(p);
    //         canvas.add(p);
    //         canvas.renderAll();
    //         // if (recentUpload) {
    //         //     $('.recent-upload-container').show();
    //         //     $('.recent-upload').prepend('<div class="imglist-item"><div class="canvas_add_replace_image" data-url="' + j.src + '"><img src="' + j.src + '"></div><span class="canvas_remove_image"></span></div>');
    //         //     if (jQuery('.imglist-item').length > 3) {
    //         //         $('.recent-upload-prev').show();
    //         //         $('.recent-upload-next').show();
    //         //         $(".recent-upload").css('left', "10px");
    //         //     } else {
    //         //         $('.recent-upload-prev').hide();
    //         //         $('.recent-upload-next').hide();
    //         //         $(".recent-upload").css('left', "0px");
    //         //     }
    //         // }
    //     }
    // }
    
    function canvas_add_image(b, a = 0, g = 0, recentUpload = true) {
        var j = new Image();
        j.src = b;
        j.onload = function () {
            var p = new fabric.Image(j);
            var imageWidth = pixelsToCentimeters(j.width);
            var imageHeight = pixelsToCentimeters(j.height);

            // Target height logic (proportional resizing)
            var targetHeight = imageHeight;

            if (imageHeight < 50) {
                targetHeight = 50; // Enlarge to 50cm if below 40cm
            } else if (imageHeight >= 80) {
                targetHeight = 80; // Reduce to 90cm if above 100cm
            }

            // Calculate scaling factor
            var scaleFactor = cmToPixel(targetHeight) / j.height; // Correctly use original height
            var newWidth = j.width * scaleFactor; // Adjust width proportionally
            
            if (pixelsToCentimeters(newWidth) >= 80) {
                scaleFactor = cmToPixel(80) / j.width;
            } 
            // else {
            //     // Apply the scale factor to the image
            //     p.scaleToHeight(cmToPixel(targetHeight));
            // }
            // p.scaleToWidth(newWidth);
            p.scale(scaleFactor);

            // Position image
            // p.left = 0;
            p.top = cmToPixel(5);
            p.orig_src = j.src;
            p.uniqId = uniqId++;
            p.crossOrigin = 'anonymous';
            
            // Add the image to the canvas and render
            const canvasWidth = canvas.getWidth() / canvas.viewportTransform[0];
            p.set({
                left: (canvasWidth - p.getScaledWidth()) / 2
            });
            canvas.add(p);
            canvas.setActiveObject(p);
            updateInputs(p);
            canvas.renderAll();

            // Handle recent uploads
            if (recentUpload) {
                $('.recent-upload-container').show();
                $('.recent-upload').prepend('<div class="imglist-item"><div class="canvas_add_replace_image" data-url="' + j.src + '"><img src="' + j.src + '"></div><span class="canvas_remove_image"></span></div>');
                if (jQuery('.imglist-item').length > 3) {
                    $('.recent-upload-prev').show();
                    $('.recent-upload-next').show();
                    $(".recent-upload").css('left', "10px");
                } else {
                    $('.recent-upload-prev').hide();
                    $('.recent-upload-next').hide();
                    $(".recent-upload").css('left', "0px");
                }
            }
        }
    }

    // Initial canvas dimensions
    var screenWidth = $(window).width();
    var sizeCanvas = canvas.getWidth() / canvas.viewportTransform[0];
    if (screenWidth < 768) {
        var cornerSize = 300;
        var controlSize = 300;
        var textFontSize = 350;
        var dimentionSize = 150;
        var widthTextTop = 120;
        resizeCanvas(canvas, sizeCanvas);
    } else if (screenWidth < 1024) {
        var cornerSize = 150;
        var controlSize = 150;
        var crop_img_corners_size = 14;
        var textFontSize = 250;
        var dimentionSize = 100;
        var widthTextTop = 80;
        resizeCanvas(canvas, sizeCanvas);
    } else if (screenWidth < 1200) {
        var cornerSize = 150;
        var controlSize = 150;
        var crop_img_corners_size = 14;
        var textFontSize = 250;
        var dimentionSize = 100;
        var widthTextTop = 80;
        resizeCanvas(canvas, sizeCanvas);
    } else {
        var cornerSize = 50;
        var controlSize = 70;
        var crop_img_corners_size = 16;
        var textFontSize = 150;
        var dimentionSize = 50;
        var widthTextTop = 40;
        resizeCanvas(canvas, sizeCanvas);
    }
    var textFontSize = 165;
    textSizeInput.value = textFontSize;
    fabric.Object.prototype.transparentCorners = false;
    fabric.Object.prototype.borderColor = "black";
    fabric.Object.prototype.cornerColor = "black";
    fabric.Object.prototype.cornerSize = 30;
    // fabric.Object.prototype.transparentCorners = true;

    function resizeCanvas(canvas, sizeBeforeResize) {
        const containerSize = {
            width: document.querySelector('.bg-canvas-holder').offsetWidth,
            height: document.querySelector('.bg-canvas-holder').offsetWidth,
        }
        if (containerSize.width === 0) {
            containerSize.width = containerSize.height = sizeBeforeResize;
        }

        const newScale = containerSize.width / sizeBeforeResize;
        // if(newScale === 0) {
        //     newScale = 1;
        // }
        const oldScale = canvas.viewportTransform[0];

        canvas.setDimensions(containerSize);
        // canvas.setZoom(newScale * oldScale);

        canvas.setViewportTransform([newScale * oldScale, 0, 0, newScale * oldScale, 0, 0]);
        canvas.renderAll();

        //canvas.zoomToPoint(new fabric.Point(canvas.width / 2, canvas.height / 2), newScale * oldScale)
        //canvas.setViewportTransform([zoom, 0, 0, zoom, 0, 0]);
    }

    function resetCanvasSize(canvas, originalSize) {
        // Apply the new dimensions to the canvas
        canvas.setDimensions({ width: originalSize.width, height: originalSize.height });

        // Set the new viewport transform, maintaining the scaling factor
        canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);

        // Re-render the canvas
        canvas.renderAll();
        resizeCanvas(canvas, canvas.getWidth() / canvas.viewportTransform[0]);
    }


    function setDefaultSize() {
        canvas.setBackgroundImage(null);
        canvas.setBackgroundColor('');
        fabric.Object.prototype.cornerSize = 25;
        addCustomRotationControl(35);
        addCustomDeleteControl(35);
        addCustomResizeControl(35);
        addWidthDimentionControls();
        addHeightDimentionControls();
        canvas.renderAll();
    }

    function setTypeTowSize() {
        canvas.setBackgroundImage(null);
        canvas.setBackgroundColor('');
        fabric.Object.prototype.cornerSize = cornerSize;
        addCustomRotationControl(controlSize);
        addCustomDeleteControl(controlSize);
        addCustomResizeControl(controlSize);
        addWidthDimentionControls(8, 20, 20, 40, dimentionSize, widthTextTop);
        addHeightDimentionControls(8, 20, 20, -40, dimentionSize);
        canvas.renderAll();
    }

    function setTypeThreeSize() {
        canvas.setBackgroundImage(null);
        canvas.setBackgroundColor('');
        var newControlSize = controlSize * 2;
        var newCornerSize = cornerSize * 2;
        var newDimentionSize = dimentionSize * 2;
        var newWidthTextTop = widthTextTop * 2;
        fabric.Object.prototype.cornerSize = newCornerSize;
        addCustomRotationControl(newControlSize);
        addCustomDeleteControl(newControlSize);
        addCustomResizeControl(newControlSize)
        addWidthDimentionControls(18, 50, 40, 70, newDimentionSize, newWidthTextTop);
        addHeightDimentionControls(18, 50, 40, -70, newDimentionSize);
        textSizeInput.value = textFontSize * 2;
        canvas.renderAll();
    }

    function addWidthDimentionControls(lineWidth = 2, widthLineTop = 0, widthLineStartEndSize = 6, widthLineStartEndOffsetY = 20, widthTextFontSize = 25, widthTextTop = 0) {
        const getCanvasScale = (fabricObject) => {
            const canvas = fabricObject.canvas;
            return canvas.viewportTransform[0];
        };

        fabric.Object.prototype.controls.widthLineStartControl = new fabric.Control({
            x: 0,
            y: 0.5,
            offsetX: 0,
            offsetY: widthLineStartEndOffsetY, // Adjust the offset to position the line below the object
            cursorStyle: 'default',
            render: function (ctx, left, top, styleOverride, fabricObject) {
                ctx.save();

                const scale = getCanvasScale(fabricObject);

                // Apply the object's transformation to the control
                ctx.translate(left, top);
                ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
                ctx.translate(-left, -top);

                var scaledWidth = fabricObject.getScaledWidth();

                // Render the start of the width line
                ctx.strokeStyle = 'black';
                ctx.lineWidth = lineWidth;
                ctx.beginPath();  // KP -  display dimention in cm of the image width
                ctx.moveTo(left - (scaledWidth * scale) / 2, top - widthLineStartEndSize);
                ctx.lineTo(left - (scaledWidth * scale) / 2, top + widthLineStartEndSize);
                ctx.stroke();

                ctx.restore();
            }
        });
        fabric.Object.prototype.controls.widthLineEndControl = new fabric.Control({
            x: 1, // Position at the right edge of the object
            y: 0.5,
            offsetX: 0,
            offsetY: widthLineStartEndOffsetY, // Adjust the offset to position the line below the object
            cursorStyle: 'default',
            render: function (ctx, left, top, styleOverride, fabricObject) {
                ctx.save();

                const scale = getCanvasScale(fabricObject);

                // Apply the object's transformation to the control
                ctx.translate(left, top);
                ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
                ctx.translate(-left, -top);

                var scaledWidth = fabricObject.getScaledWidth();

                // Render the end of the width line
                ctx.strokeStyle = 'black';
                ctx.lineWidth = lineWidth;
                ctx.beginPath();  // KP -  display dimention in cm of the image width
                ctx.moveTo(left - (scaledWidth * scale) / 2, top - widthLineStartEndSize);
                ctx.lineTo(left - (scaledWidth * scale) / 2, top + widthLineStartEndSize);
                ctx.stroke();

                ctx.restore();
            }
        });

        fabric.Object.prototype.controls.widthLineControl = new fabric.Control({
            x: 0,
            y: 0.5,
            offsetX: 0,
            offsetY: 25, // Adjust the offset to position the line below the object
            cursorStyle: 'default',
            render: function (ctx, left, top, styleOverride, fabricObject) {
                ctx.save();

                ctx.translate(left, top);
                ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
                ctx.translate(-left, -top);

                const scale = getCanvasScale(fabricObject);

                // Calculate scaled dimensions
                var scaledWidth = fabricObject.getScaledWidth();
                var scaledHeight = fabricObject.getScaledHeight();

                // Calculate the position of the line
                var lineY = top - 5 + widthLineTop;

                // Render the width line
                ctx.strokeStyle = 'black';
                ctx.lineWidth = lineWidth;
                ctx.beginPath(); // KP -  display dimention in cm of the image width
                ctx.moveTo(left - (scaledWidth * scale) / 2, lineY);
                ctx.lineTo(left + (scaledWidth * scale) / 2, lineY);
                ctx.stroke();

                ctx.restore();
            }
        });
        /*KP - Mobile screen masurement text display in position */
         const isMobileforwidth = window.innerWidth <= 767;
         /*KP - Mobile screen masurement text display in position */

        fabric.Object.prototype.controls.widthControl = new fabric.Control({
            x: 0,
            y: 0.5,
            offsetX: 0,
            offsetY: 20,
            cursorStyle: 'default',
            render: function (ctx, left, top, styleOverride, fabricObject) {
                ctx.save();

                ctx.translate(left, top);
                ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
                ctx.translate(-left, -top);
                /*KP - Mobile screen masurement text display in position */
                var measureTextadditionval = isMobileforwidth ? 15 : 20;
                var widthTextFontSizeNew = isMobileforwidth ? 20 : widthTextFontSize;
                /*KP - Mobile screen masurement text display in position */
                ctx.font = 'bold ' + widthTextFontSizeNew + 'px Arial'; //KP - Mobile screen masurement text display in position 
                ctx.fillStyle = 'black';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';

                // var scaledWidth = fabricObject.getScaledWidth();
                var scaledWidth = fabricObject.width * fabricObject.scaleX;
                var widthText = pixelsToCentimeters(scaledWidth) + 'cm';

                ctx.fillStyle = 'black'; // KP - display width of the image ex 25cm
                ctx.fillText(widthText, left, top + measureTextadditionval + widthTextTop); //KP - Mobile screen masurement text display in position 
                ctx.restore();
            }
        });
    }

    function addHeightDimentionControls(lineWidth = 2, heightLineLeft = 0, heightLineStartEndSize = 6, heightLineStartEndOffsetX = -20, heightTextFontSize = 25) {
        const getCanvasScale = (fabricObject) => {
            const canvas = fabricObject.canvas;
            return canvas.viewportTransform[0];
        };

        // Define a custom control for displaying the height line
        fabric.Object.prototype.controls.heightLineStartControl = new fabric.Control({
            x: -0.5, // Position on the left side of the object
            y: -0.5,
            offsetX: heightLineStartEndOffsetX, // Adjust the offset to position the line correctly
            offsetY: 0,
            cursorStyle: 'default',
            render: function (ctx, left, top, styleOverride, fabricObject) {
                ctx.save();

                // Apply the object's transformation to the control
                ctx.translate(left, top);
                ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
                ctx.translate(-left, -top);

                // Calculate the position of the height line start
                var leftPosition = left - 1;

                // Render the height line start
                ctx.strokeStyle = 'black';
                ctx.lineWidth = lineWidth;
                ctx.beginPath(); // KP - display dimention in cm of the image height
                ctx.moveTo(leftPosition - heightLineStartEndSize, top);
                ctx.lineTo(leftPosition + heightLineStartEndSize, top);
                ctx.stroke();

                ctx.restore();
            }
        });

        fabric.Object.prototype.controls.heightLineEndControl = new fabric.Control({
            x: -0.5, // Position on the left side of the object
            y: 0.5,
            offsetX: heightLineStartEndOffsetX, // Adjust the offset to position the line correctly
            offsetY: 0,
            cursorStyle: 'default',
            render: function (ctx, left, top, styleOverride, fabricObject) {
                ctx.save();

                // Apply the object's transformation to the control
                ctx.translate(left, top);
                ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
                ctx.translate(-left, -top);

                // Calculate the position of the height line end
                var leftPosition = left - 1;

                // Render the height line end
                ctx.strokeStyle = 'black';
                ctx.lineWidth = lineWidth;
                ctx.beginPath(); // KP - display dimention in cm of the image height
                ctx.moveTo(leftPosition - heightLineStartEndSize, top);
                ctx.lineTo(leftPosition + heightLineStartEndSize, top);
                ctx.stroke();

                ctx.restore();
            }
        });

        fabric.Object.prototype.controls.heightLineControl = new fabric.Control({
            x: -0.5, // Position on the left side of the object
            y: 0,
            offsetX: -20, // Adjust the offset to position the line correctly
            offsetY: 0,
            cursorStyle: 'default',
            render: function (ctx, left, top, styleOverride, fabricObject) {
                ctx.save();

                // Apply the object's transformation to the control
                ctx.translate(left, top);
                ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
                ctx.translate(-left, -top);

                const scale = getCanvasScale(fabricObject);

                // Calculate the position of the height line
                var scaledHeight = fabricObject.height * fabricObject.scaleY;
                var leftPosition = left - 1 - heightLineLeft;

                // Render the height line
                ctx.strokeStyle = 'black';
                ctx.lineWidth = lineWidth;
                ctx.beginPath(); // KP - display dimention in cm of the image height
                ctx.moveTo(leftPosition, top - (scaledHeight * scale) / 2);
                ctx.lineTo(leftPosition, top + (scaledHeight * scale) / 2);
                ctx.stroke();

                ctx.restore();
            }
        });
        /*KP - Mobile screen masurement text display in position */
        const isMobileforheight = window.innerWidth <= 767;
        /*KP - Mobile screen masurement text display in position */
        fabric.Object.prototype.controls.heightControl = new fabric.Control({
            x: 0,
            y: 0.5,
            offsetX: -20, // Adjust the offset to position the text correctly
            offsetY: 0,
            cursorStyle: 'default',
            render: function (ctx, left, top, styleOverride, fabricObject) {
                ctx.save();

                // Apply the object's transformation to the control
                ctx.translate(left, top);
                ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
                ctx.translate(-left, -top);

                const scale = getCanvasScale(fabricObject);

                /*KP - Mobile screen masurement text display in position */
                var measureTextadditionval = isMobileforheight ? 10 : 20;
                var heightTextFontSizeNew = isMobileforheight ? 20 : heightTextFontSize;
                /*KP - Mobile screen masurement text display in position */

                ctx.font = 'bold ' + heightTextFontSizeNew + 'px Arial'; /*KP - Mobile screen masurement text display in position */
                ctx.fillStyle = 'black';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';

                // Get the height in centimeters
                var scaledHeight = fabricObject.height * fabricObject.scaleY;
                var scaledWidth = fabricObject.width * fabricObject.scaleX;
                var heightText = pixelsToCentimeters(scaledHeight) + 'cm';

                // Draw the height text
                ctx.fillStyle = 'black'; // KP - display height of the image ex 25cm
                ctx.fillText(heightText, left - (scaledWidth * scale) / 2 - ctx.measureText(heightText).width + measureTextadditionval, top - (scaledHeight * scale) / 2);
                // KP - Mobile screen masurement text display in position 
                ctx.restore();
            }
        });
    }

    function renderIcon(icon) {
        return function renderIcon(ctx, left, top, styleOverride, fabricObject) {
            var size = this.cornerSize;
            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(icon, -size / 2, -size / 2, size, size);
            ctx.restore();
        }
    }

    async function addCustomRotationControl(controlSize) {
        try {
            const img = await loadImage("https://cdn.shopify.com/s/files/1/0823/4654/1395/files/refresh.png?v=1718011340");
            // Math.min(canvas.width, canvas.height) * 0.05; // 5% of the smallest dimension
            var renderData = false;
            if (controlSize == undefined) {
                renderData = true;
                controlSize = 35;
            }
            img.scaleToWidth(controlSize);
            // img.scaleToWidth(25);
            const rotationIconDataUrl = img.toDataURL();
            const rotationIcon = document.createElement('img');
            rotationIcon.src = rotationIconDataUrl;

            const mtr = new fabric.Control({
                x: 0.5,
                y: -0.5,
                actionHandler: fabric.controlsUtils.rotationWithSnapping,
                cursorStyleHandler: fabric.controlsUtils.rotationStyleHandler,
                withConnection: true,
                actionName: 'rotate',
                cursorStyle: 'pointer',
                render: renderIcon(rotationIcon),
                cornerSize: controlSize,
            });

            fabric.Object.prototype.controls.mtr = mtr;
            // Redraw canvas to ensure the control is visible
            if (renderData) {
                canvas.renderAll();
            }
        } catch (error) {
            console.error(error);
        }
    }

    async function loadImage(url) {
        return new Promise((resolve, reject) => {
            fabric.Image.fromURL(url, function (img, isError) {
                if (isError) {
                    reject(isError);
                } else {
                    resolve(img);
                }
            }, { crossOrigin: 'Anonymous' });
        });
    }

    // Define the deleteObject function
    function deleteObject() {
        const activeObject = canvas.getActiveObject();
        if (activeObject) {
            canvas.remove(activeObject);
            canvas.requestRenderAll();
        }
        if (activeObject && activeObject.type == "i-text") {
            $('#bg_canvas_texttransform').val("");
            // resetTextData();
        }
    }


    async function addCustomDeleteControl(controlSize) {
        try {
            const img = await loadImage("https://cdn.shopify.com/s/files/1/0823/4654/1395/files/button.png?v=1718011339");

            var renderData = false;
            if (controlSize == undefined) {
                renderData = true;
                controlSize = 35;
            }
            img.scaleToWidth(controlSize);

            const deleteIconDataUrl = img.toDataURL();
            const deleteIcon = document.createElement('img');
            deleteIcon.src = deleteIconDataUrl;

            const deleteControl = new fabric.Control({
                x: -0.5,
                y: -0.5,
                cursorStyle: 'pointer',
                mouseUpHandler: deleteObject,
                render: renderIcon(deleteIcon),
                cornerSize: controlSize,
            });

            fabric.Object.prototype.controls.deleteControl = deleteControl;

            if (renderData) {
                // Redraw canvas to ensure the control is visible
                canvas.renderAll();
            }
        } catch (error) {
            console.error(error);
        }
    }

    async function addCustomResizeControl(controlSize) {
        try {
            const img = await loadImage("https://cdn.shopify.com/s/files/1/0823/4654/1395/files/left-and-right-arrows.png?v=1718011339");
            // Math.min(canvas.width, canvas.height) * 0.05; // 5% of the smallest dimension
            var renderData = false;
            if (controlSize == undefined) {
                renderData = true;
                controlSize = 35;
            }
            img.scaleToWidth(controlSize);
            // img.scaleToWidth(25);
            const resizeIconDataUrl = img.toDataURL();
            const resizeIcon = document.createElement('img');
            resizeIcon.src = resizeIconDataUrl;

            const resizeDataControl = new fabric.Control({
                x: 0.5,
                y: 0.5,
                actionHandler: fabric.controlsUtils.scalingEqually,
                cursorStyleHandler: fabric.controlsUtils.scaleCursorStyleHandler,
                withConnection: true,
                actionName: 'scale',
                cursorStyle: 'pointer',
                render: renderIcon(resizeIcon),
                cornerSize: controlSize,
            });

            fabric.Object.prototype.controls.resizeControl = resizeDataControl;
            // Redraw canvas to ensure the control is visible
            if (renderData) {
                canvas.renderAll();
            }
        } catch (error) {
            console.error(error);
        }
    }

    // addWidthDimentionControls(8, 20, 20, 40, dimentionSize, widthTextTop);
    // addHeightDimentionControls(8, 20, 20, -40, dimentionSize);
    addWidthDimentionControls();
    addHeightDimentionControls();
    addCustomRotationControl();
    addCustomDeleteControl();
    addCustomResizeControl();

    function addRulers(canvasWidth, canvasHeight) {
        // Add horizontal ruler (X axis)
        var $rulerX = $('#rulerX .ruler');
        $rulerX.empty();
        $rulerX.css('width', canvasWidth + 'px');
        for (let i = 0; i <= canvasWidth; i += cmToPixel(2)) { // Increment by 2 centimeters
            var widthCm = Math.round(i / cmToPixel(1));
            var $span = $('<div class="cm" style="left: ' + i + 'px;width: ' + cmToPixel(2) + 'px;"><span>' + widthCm + '</span></div>');
            for (let j = 0; j < 9; j++) {
                $span.append('<div class="mm"></div>');
            }
            $rulerX.append($span);
        }

        // Add vertical ruler (Y axis)
        var $rulerY = $('#rulerY .ruler');
        $rulerY.empty();
        $rulerY.css('height', canvasHeight + 'px');
        for (let i = 0; i <= canvasHeight; i += cmToPixel(2)) { // Increment by 2 centimeters
            var heightCm = Math.round(i / cmToPixel(1));
            var $span = $('<div class="cm" style="top: ' + i + 'px;height: ' + cmToPixel(2) + 'px;"><span>' + heightCm + '</span></div>');
            for (let j = 0; j < 9; j++) {
                $span.append('<div class="mm"></div>');
            }
            $rulerY.append($span);
        }
    }

    // Function to convert centimeters to pixels
    function cmToPixel(cm) {
        return cm * (96 / 2.54); // 96 pixels per inch / 2.54 centimeters per inch
    }

    canvas.on("mouse:down", function (d) { // , touch:gesture
        if (d.target) {
            $('.bg-update-canvas').hide();
            switch (d.target.type) {
                case "text":
                case "i-text":
                    $('#bg_canvas_texttransform').val(d.target.text);
                    updateTextData(d.target);
                    updateTextInputs(d.target);
                    scaleXdata = "";
                    scaleYdata = "";
                    break;
                case "image":
                    $('#bg_canvas_texttransform').val("");
                    resetTextData();
                    updateInputs(d.target);
                    scaleXdata = "";
                    scaleYdata = "";
                    //imageScaleSlider.value = 50;
                    //const progress = (50 / sliderEl.max) * 100;
                    //sliderEl.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${progress}%, #ccc ${progress}%)`;
                    break;
                case "group":
                case "circle":
                case "rect":
                    break
                case "line":
                case "triangle":
                case "path-group":
                    break
            }
        } else {
            $('#bg_canvas_texttransform').val("");
            // resetTextData();
        }
        canvas.renderAll();
    });


    function pixelsToCentimeters(pixels) {
        var dpi = 96; // Default DPI assumption
        // 1 inch = 2.54 cm
        var inches = pixels / dpi;
        var centimeters = inches * 2.54;
        return centimeters.toFixed(0);
    }

    fabric.Canvas.prototype.removeObjectByName = function (name) {
        var object = null,
            objects = this.getObjects();

        for (var i = 0, len = this.size(); i < len; i++) {
            if (objects[i].name && objects[i].name === name) {
                object = objects[i];
                break;
            }
        }
        if (object != null) {
            canvas.remove(object);
        }
        return true;
    };

    jQuery(".remove-single-image").on('click', function () {
        if (canvas.getActiveObject()) {
            removeDimentionText(canvas.getActiveObject());
            canvas.remove(canvas.getActiveObject());
            $('.image-update-canvas').hide();
        }
    });

    jQuery(".remove-bg").on('click', function (d) {
        d.preventDefault();
        canvas.backgroundImage = null;
        canvas.renderAll();
        bgImage = "";
        $('.bg-update-canvas').hide();
    });

    // Update text properties on change
    fontFamilySelect.addEventListener('change', function () {
        updateTextProperties();
    });
    textSizeInput.addEventListener('input', function () {
        updateTextProperties();
    });
    textColorInput.addEventListener('input', function () {
        updateTextProperties();
    });
    boldCheckbox.addEventListener('change', function () {
        updateTextProperties();
    });
    italicCheckbox.addEventListener('change', function () {
        updateTextProperties();
    });
    underlineCheckbox.addEventListener('change', function () {
        updateTextProperties();
    });

    function updateTextProperties() {
        const boldFonts = ["Dancing Script", "Droid Sans", "Droid Serif", "Gloria Hallelujah", "Indie Flower", "Lato", "lato", "Lora", "Montserrat", "Open Sans", "Oswald", "PT Sans", "PT Serif", "Pacifico", "Playfair Display", "Raleway", "Roboto", "Roboto Condensed", "Roboto Slab", "Rubik", "Slabo 27px", "Source Sans Pro", "Ubuntu", "Finger Paint", "Teko", "Josefin Sans", "Varela Round", "Berkshire Swash", "Cabin Sketch", "Electrolize", "Niconne", "Reem Kufi", "Love Ya Like A Sister", "Vast Shadow", "Ravi Prakash", "Pirata One", "Great Vibes", "Bree Serif", "Kaushan Script", "Cookie", "Patrick Hand", "Boogaloo", "Playball", "Oleo Script", "Nova Square", "New Rocker"];
        let isFontsBold = false;
        if (boldFonts.includes(fontFamilySelect.value)) {
            isFontsBold = true;
            boldCheckbox.disabled = true;
            boldCheckbox.checked = false;
        } else {
            boldCheckbox.disabled = false;
        }
        const activeObject = canvas.getActiveObject();
        if (activeObject && activeObject.type === 'i-text') {
            activeObject.set({
                fontFamily: fontFamilySelect.value,
                fontSize: parseInt(textSizeInput.value),
                fill: textColorInput.value,
                fontWeight: (boldCheckbox.checked || isFontsBold) ? 'bold' : 'normal',
                fontStyle: italicCheckbox.checked ? 'italic' : 'normal',
                underline: underlineCheckbox.checked,
            });
            canvas.fire('object:scaling', { target: activeObject });
            canvas.renderAll();
            // updateModifications()
        }
    }

    // Add text on button click
    // document.getElementById('addTextBtn').addEventListener('click', function () {
    //     const canvasHeight = canvas.getHeight() / canvas.viewportTransform[3];
    //     const additionalValue = (canvasHeight / 6); // Adjust this value as needed
    //     const text = new fabric.IText('Tap and Type', {
    //         left: 100,
    //         top: (canvasHeight / 2) + additionalValue,
    //         fontFamily: fontFamilySelect.value,
    //         fontSize: parseInt(250),
    //         fill: textColorInput.value,
    //         fontWeight: boldCheckbox.checked ? 'bold' : 'normal',
    //         fontStyle: italicCheckbox.checked ? 'italic' : 'normal',
    //         underline: underlineCheckbox.checked,
    //         selectable: true,
    //     });
    //     canvas.add(text);
        
    //     // Set the left position to center the text horizontally
    //     const canvasWidth = canvas.getWidth() / canvas.viewportTransform[0];
    //     const textWidth = text.getScaledWidth();
    //     const centerX = (canvasWidth - textWidth) / 2;
    //     text.set('left', centerX);

    //     canvas.setActiveObject(text);
    //     updateTextInputs(text);
    //     canvas.renderAll();
    // });

    function updateTextData(object) {
        // Update input controls with the selected textbox properties
        fontFamilySelect.value = object.fontFamily;
        sBtn_text.innerText = fontFamilySelect.value;
        
        textSizeInput.value = object.fontSize;
        textColorInput.value = object.fill;
        // boldCheckbox.checked = object.fontWeight === 'bold';
        // const boldFonts = ["Dancing Script", "Droid Sans", "Droid Serif", "Gloria Hallelujah", "Indie Flower", "Lato", "Lora", "Montserrat", "Open Sans", "Oswald", "PT Sans", "PT Serif", "Pacifico", "Playfair Display", "Raleway", "Roboto", "Roboto Condensed", "Roboto Slab", "Rubik", "Slabo 27px", "Source Sans Pro", "Ubuntu", "Finger Paint", "Teko", "Josefin Sans", "Varela Round", "Berkshire Swash", "Cabin Sketch", "Electrolize", "Niconne", "Reem Kufi", "Love Ya Like A Sister", "Vast Shadow", "Ravi Prakash", "Pirata One", "Great Vibes", "Bree Serif", "Kaushan Script", "Cookie", "Patrick Hand", "Boogaloo", "Playball", "Oleo Script", "Nova Square", "New Rocker"];
        // if (boldFonts.includes(fontFamilySelect.value)) {
        //     boldCheckbox.disabled = true;
        //     boldCheckbox.checked = false;
        // } else {
        //     boldCheckbox.checked = object.fontWeight === 'bold';
        // }
        italicCheckbox.checked = object.fontStyle === 'italic';
        underlineCheckbox.checked = object.underline;
    }

    Coloris({
        el: '.bgColorPicker',
        swatches: [
            '#FF0000', '#FFFFFF', '#00FFFF', '#C0C0C0',
            '#0000FF', '#808080', '#000000', '#ADD8E6',
            '#FFA500', '#800080', '#A52A2A', '#FFFF00',
            '#800000', '#00FF00', '#008000', '#FF00FF',
            '#808000', '#FFC0CB',
        ]
    });

    // Undo/Redo
    var myUndoRedoConfig = {
        canvasState: [],
        currentStateIndex: -1,
        undoStatus: false,
        redoStatus: false,
        undoFinishedStatus: 1,
        redoFinishedStatus: 1,
        // undoButton: document.getElementById('undo'),
        // redoButton: document.getElementById('redo'),
    };

    resetUndoRedo();

    function resetUndoRedo() {
        myUndoRedoConfig.canvasState = [];
        myUndoRedoConfig.currentStateIndex = -1;
        myUndoRedoConfig.undoStatus = false;
        myUndoRedoConfig.redoStatus = false;
        myUndoRedoConfig.undoFinishedStatus = 1;
        myUndoRedoConfig.redoFinishedStatus = 1;
        // myUndoRedoConfig.undoButton.disabled = "disabled";
        // myUndoRedoConfig.redoButton.disabled = "disabled";
    }

    function updateModifications() {
        if ((myUndoRedoConfig.undoStatus == false && myUndoRedoConfig.redoStatus == false)) {
            var jsonData = canvas.toJSON();
            var canvasAsJson = JSON.stringify(jsonData);
            if (myUndoRedoConfig.currentStateIndex < myUndoRedoConfig.canvasState.length - 1) {
                var indexToBeInserted = myUndoRedoConfig.currentStateIndex + 1;
                myUndoRedoConfig.canvasState[indexToBeInserted] = canvasAsJson;
                var numberOfElementsToRetain = indexToBeInserted + 1;
                myUndoRedoConfig.canvasState = myUndoRedoConfig.canvasState.splice(0, numberOfElementsToRetain);
            } else {
                myUndoRedoConfig.canvasState.push(canvasAsJson);
            }
            myUndoRedoConfig.currentStateIndex = myUndoRedoConfig.canvasState.length - 1;
            if ((myUndoRedoConfig.currentStateIndex == myUndoRedoConfig.canvasState.length - 1) && myUndoRedoConfig.currentStateIndex != -1) {
                myUndoRedoConfig.redoButton.disabled = "disabled";
            }
            myUndoRedoConfig.undoButton.removeAttribute('disabled');
        }
    }

    var undo = function () {
        if (myUndoRedoConfig.undoFinishedStatus) {
            if (myUndoRedoConfig.currentStateIndex == -1) {
                myUndoRedoConfig.undoStatus = false;
            } else {
                if (myUndoRedoConfig.canvasState.length >= 1) {
                    myUndoRedoConfig.undoFinishedStatus = 0;
                    if (myUndoRedoConfig.currentStateIndex != 0) {
                        myUndoRedoConfig.undoStatus = true;
                        canvas.loadFromJSON(myUndoRedoConfig.canvasState[myUndoRedoConfig.currentStateIndex - 1], function () {
                            var jsonData = JSON.parse(myUndoRedoConfig.canvasState[myUndoRedoConfig.currentStateIndex - 1]);
                            canvas.renderAll();
                            myUndoRedoConfig.undoStatus = false;
                            myUndoRedoConfig.currentStateIndex -= 1;
                            myUndoRedoConfig.undoButton.removeAttribute("disabled");
                            if (myUndoRedoConfig.currentStateIndex !== myUndoRedoConfig.canvasState.length - 1) {
                                myUndoRedoConfig.redoButton.removeAttribute('disabled');
                            }
                            myUndoRedoConfig.undoFinishedStatus = 1;
                        });
                    } else if (myUndoRedoConfig.currentStateIndex == 0) {
                        canvas.clear();
                        myUndoRedoConfig.undoFinishedStatus = 1;
                        myUndoRedoConfig.undoButton.disabled = "disabled";
                        myUndoRedoConfig.redoButton.removeAttribute('disabled');
                        myUndoRedoConfig.currentStateIndex -= 1;
                    }
                }
            }
        }
    }

    var redo = function () {
        if (myUndoRedoConfig.redoFinishedStatus) {
            if ((myUndoRedoConfig.currentStateIndex == myUndoRedoConfig.canvasState.length - 1) && myUndoRedoConfig.currentStateIndex != -1) {
                myUndoRedoConfig.redoButton.disabled = "disabled";
            } else {
                if (myUndoRedoConfig.canvasState.length > myUndoRedoConfig.currentStateIndex && myUndoRedoConfig.canvasState.length != 0) {
                    myUndoRedoConfig.redoFinishedStatus = 0;
                    myUndoRedoConfig.redoStatus = true;
                    canvas.loadFromJSON(myUndoRedoConfig.canvasState[myUndoRedoConfig.currentStateIndex + 1], function () {
                        var jsonData = JSON.parse(myUndoRedoConfig.canvasState[myUndoRedoConfig.currentStateIndex + 1]);
                        canvas.renderAll();
                        myUndoRedoConfig.redoStatus = false;
                        myUndoRedoConfig.currentStateIndex += 1;
                        if (myUndoRedoConfig.currentStateIndex != -1) {
                            myUndoRedoConfig.undoButton.removeAttribute('disabled');
                        }
                        myUndoRedoConfig.redoFinishedStatus = 1;
                        if ((myUndoRedoConfig.currentStateIndex == myUndoRedoConfig.canvasState.length - 1) && myUndoRedoConfig.currentStateIndex != -1) {
                            myUndoRedoConfig.redoButton.disabled = "disabled";
                        }
                    });
                }
            }
        }
    }

    // myUndoRedoConfig.undoButton.addEventListener('click', function () {
    //     undo();
    // });

    // myUndoRedoConfig.redoButton.addEventListener('click', function () {
    //     redo();
    // });

    /* Zoom functions */
    function zoomTo(zoom = 1) {
        if (zoom < 0.2) {
            zoom = 0.1
        }
        // if (zoom === 0.7 || zoom === 0.65) {
        //     zoom = 1;
        // }
        var canvasContainer = jQuery(".bg-canvas-wrapper .canvas-container");
        var canvasContainerWidth = canvasContainer.width();
        var canvasContainerHeight = canvasContainer.height();
        var canvasHolderWidth = jQuery(".bg-canvas-holder").outerWidth();
        var canvasHolderHeight = jQuery(".bg-canvas-holder").outerHeight();
        var leftPosition = canvasHolderWidth / 2 - (canvasContainerWidth * zoom) / 2 + 10;
        var topPosition = canvasHolderHeight / 2 - (canvasContainerHeight * zoom) / 2 + 10;
        canvasContainer.css({
            transform: "scale(" + zoom + ")",
            position: "absolute"
        });
        if (canvasHolderWidth < canvasContainerWidth * zoom) {
            leftPosition = 10
        }
        if (canvasHolderHeight < canvasContainerHeight * zoom) {
            topPosition = 10
        }
        canvasContainer.css({
            left: leftPosition,
            top: topPosition
        });
        var zoomdata = zoom.toFixed(1);
        var zoomPercentage = zoomdata * 100;
        jQuery(".zoom-value-hidden").val(zoomdata);
        jQuery(".zoom-value").text(zoomPercentage.toFixed() + '%');
    }

    /*jQuery(".zoom-in").on('click', function (d) {
        var zoom = parseFloat(jQuery(".zoom-value-hidden").val()) || 1;
        zoom += 0.1;
        zoomTo(zoom);
    });
    jQuery(".zoom-out").on('click', function (d) {
        var zoom = parseFloat(jQuery(".zoom-value-hidden").val()) || 1;
        zoom -= 0.1;
        zoomTo(zoom);
    });*/

    /*$('.recent-upload .imglist-item:first-of-type').before($('.recent-upload .imglist-item:last-of-type'));
    $('.recent-upload').css('left', '-' + $('.recent-upload .imglist-item:first-of-type').width() + 'px');

    $('.recent-upload-prev').click(function () {
        var a = $('.recent-upload .imglist-item:first-of-type');
        var width = a.width();
        var movement = parseInt($('.recent-upload').css('left')) + width;
        $('.recent-upload:not(:animated)').animate({ 'left': movement + 'px' }, 500, function () {
            $('.recent-upload .imglist-item:first-of-type').before($('.recent-upload .imglist-item:last-of-type'));
            width = $('.recent-upload .imglist-item:first-of-type').width();
            $('.recent-upload').css({ 'left': '-' + width + 'px' });
        });
    });

    $('.recent-upload-next').click(function () {
        var a = $('.recent-upload .imglist-item:nth-child(2)');
        var width = a.width();
        var movement = parseInt($('.recent-upload').css('left')) - width;
        $('.recent-upload:not(:animated)').animate({ 'left': movement + 'px' }, 500, function () {
            $('.recent-upload .imglist-item:last-of-type').after($('.recent-upload .imglist-item:first-of-type'));
            width = $('.recent-upload .imglist-item:first-of-type').width();
            $('.recent-upload').css({ 'left': '-' + width + 'px' });
        });
    });*/

    /* KP - popup before blank add to cart start */
    const cartpopup = document.getElementById("cartpopup");
    const cartpopupcloseBtn = document.querySelector(".cartpopupclose");

    // cartpopupClose the cartpopup when the 'x' is clicked
    cartpopupcloseBtn.onclick = function() {
           cartpopup.style.display = "none";
    };

    // cartpopupClose the cartpopup when clicking outside the cartpopup content
    window.onclick = function(event) {
        if (event.target === cartpopup) {
            cartpopup.style.display = "none";
        }
    };
    /* KP - popup before blank add to cart end*/

    $('#add-to-cart-item').on('click', async function (e) {
        var alertContent = "";
        if (canvas.getObjects().length < 1) {
            cartpopup.style.display = "flex"; // KP - popup before blank add to cart start
            return false;
        }
        $('.bg-loader').show();
        var objs = canvas.getObjects();
        var exportDataTmp = {};
        var exportDataImageTmp = {};
        var textObjecttitle = '';
        var textObjectcontent = '';
        var MainTitle = 'Your Custom Wall Sticker Details';
        var Maincontent = 'NULL';
        var ImageObjecttitle = '';
        var ImageObjectcontent = 'NULL';
        var exportData = {};
        var exportDataImagetitle = {};
        var heightWidthData = "";
        // Loop through each object and log its data
        let textCount = 1;
        objs.forEach(function(obj, index) {
            const scale = canvas.viewportTransform[0];
            // Get the height in centimeters
            var scaledHeight = obj.height * obj.scaleY;
            var scaledWidth = obj.width * obj.scaleX;
            heightWidthData = "Width: "+pixelsToCentimeters(scaledWidth) + 'cm'+", Height: "+pixelsToCentimeters(scaledHeight) + 'cm';
            if (obj.type == "image") {
                let imageDimensions = "Dimensions";
                exportDataImageTmp = {...exportDataImageTmp, ...{ [imageDimensions]: heightWidthData }};
                ImageObjecttitle = 'Photo';
            }else if (obj.type == "i-text") {
                let textObjectKey = '';
                let DimentionObjectKey ='';
                let textContentData = "'"+obj.text+"'";
                let textDimentionData = heightWidthData+" | Font: "+obj.fontFamily;
                if(textCount == 1){
                    textObjecttitle = "Text";
                    textObjectcontent = " "; 
                    textObjectKey = "Quote_"+textCount;    
                    DimentionObjectKey = "Dimensions_"+textCount;    
                }else{
                    textObjectKey = "Quote_"+textCount;    
                    DimentionObjectKey = "Dimensions_"+textCount;    
                }
                exportDataTmp = {...exportDataTmp,...{[textObjecttitle]: textObjectcontent }, ...{ [textObjectKey]: textContentData },...{[DimentionObjectKey]: textDimentionData}};
                textCount++;                
            }
        });

        var realSizeData = calculateRealSize(canvas);
        var newWidth = cmToPixel(realSizeData.width);
        var newHeight = cmToPixel(realSizeData.height);

        if (canvas.width !== newWidth || canvas.height !== newHeight) {
            canvas.setDimensions({ width: newWidth, height: newHeight });
            canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
            canvas.renderAll();
        }

        var exportOptions = {
            format: 'png',
            quality: 0.8 // Reduced quality for performance
        };
        var canvasDataURL = canvas.toDataURL(exportOptions);
        // Create a new worker with an absolute path
        var worker = new Worker("//inspirewallsticker.com/cdn/shop/t/1/assets/blobWorker.js?v=114813312301117022731719384370");

        worker.postMessage({ dataURL: canvasDataURL });
        worker.onmessage = function (e) {
            var blob = e.data;

            const formData = new FormData();
            formData.append('image', blob, 'canvas_image.png');
            formData.append('canvasSize', realSizeData.width + 'x' + realSizeData.height);
            // Send the image to the PHP file via AJAX
            $.ajax({
                url: 'https://inspirewallsticker.photos/productapi.php',
                type: 'POST',
                data: formData,
                processData: false,
                contentType: false,
                success: function (response) {
                    if (!response.id || !response.real_image) {
                        console.error('Invalid response from API:', response);
                        $('.bg-loader').hide();
                        return;
                    }
                    // exportDataImagetitle = {...{[MainTitle]: [Maincontent]},...{ [ImageObjecttitle]: [ImageObjectcontent]}};
                    exportDataImagetitle = {...{ [ImageObjecttitle]: [ImageObjectcontent]}};
                    exportData = { Preview: response.real_image };
                  if (ImageObjecttitle == ""){
                    exportData = {...exportData,...exportDataImageTmp, ...exportDataTmp};
                  } else {
                    exportData = {...exportDataImagetitle,...exportData,...exportDataImageTmp, ...exportDataTmp};
                  }
                    jQuery.ajax({
                      url: 'https://inspirewallsticker.com/cart/add.js',
                      type: 'POST',
                      data: {
                          quantity: 1,
                          id: response.id,
                          properties: exportData
                      },
                      success: function (result) {
                          window.location.href = "https://inspirewallsticker.com/cart";
                          $('.bg-loader').hide();
                      },
                      error: function (jqxhr, status, exception) {
                          if (jqxhr.status == 200) {
                              window.location.href = "https://inspirewallsticker.com/cart";
                          }
                          $('.bg-loader').hide();
                      }
                  });
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    console.error('Error saving image to Shopify:', textStatus, errorThrown);
                    $('.bg-loader').hide();
                }
            });
        };
    });

    /* Image scaling feature */
    const imageScaleSlider = document.getElementById('imagescale');
    const imageWidthInput = document.getElementById('imagewidth');
    const imageHeightInput = document.getElementById('imageheight');
    const textScaleSlider = document.getElementById('textSizeInput');
    const textWidthInput = document.getElementById('textwidth');
    const textHeightInput = document.getElementById('textheight');

    let originalWidth, originalHeight, textOriginalWidth, textOriginalHeight;

    // Ensure both width and height are updated to maintain aspect ratio
    canvas.on('object:scaling', function () {
        const activeObj = canvas.getActiveObject();
        if (activeObj.type == "image") {       
            updateInputs(activeObj);
        } else if (activeObj.type == "i-text") {
            updateTextInputs(activeObj);
        }
    });
    canvas.on('object:added', function (currentObj) {
        if (currentObj.target.type == "image") {
            originalWidth = currentObj.target.width;
            originalHeight = currentObj.target.height;
        } else if (currentObj.target.type == "i-text") {
            textOriginalWidth = currentObj.target.width;
            textOriginalHeight = currentObj.target.height;
        }
    });
   
   
    function updateTextInputs(text) {
        var textWidth = text.width * text.scaleX;
        var textHeight = text.height * text.scaleY;
        textWidthInput.value = pixelsToCentimeters(textWidth);
        textHeightInput.value = pixelsToCentimeters(textHeight);
        const progress = (textScaleSlider.value / textScaleSlider.max) * 100;

        textScaleSlider.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${progress}%, #ccc ${progress}%)`;
        /* KP - hide control while typing text */
         // KP - Show controls after typing stops
        debounce(() => {
            text.set({
                hasControls: true,
                hasBorders: true,
            });
            canvas.renderAll(); // Re-render the canvas
        }, 400); // KP - Adjust debounce delay as needed
        /* KP - hide control while typing text functionality*/
    }

    function updateInputs(img) {
        var imgWidth = img.width * img.scaleX;
        var imgHeight = img.height * img.scaleY;
        imageWidthInput.value = pixelsToCentimeters(imgWidth);
        imageHeightInput.value = pixelsToCentimeters(imgHeight);

        var imgactualwidth = pixelsToCentimeters(imgWidth);
        var remainingwidth = 100 - imgactualwidth;
       
        imageScaleSlider.value = imgactualwidth;
        imageScaleSlider.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${imgactualwidth}%, #ccc ${imgactualwidth}%)`;
         /*const progress = (imageScaleSlider.value / imageScaleSlider.max) * 100;
         const minus_progress = imageScaleSlider.max - progress;
        imageScaleSlider.style.background = `linear-gradient(to right, #0d6efd ${progress}%, #ccc ${minus_progress}%)`;*/

    }

    let previousSliderValue = imageScaleSlider.value;  // KP - Image resize slider

    textScaleSlider.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
        if (activeObj && activeObj.type == "i-text") {
            updateTextInputs(activeObj);
        }
    });

    // Event listener for width input
    textWidthInput.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
        if (parseFloat(textWidthInput.value) > 100) {
            textWidthInput.value = 100;
        }
        if (activeObj && activeObj.type == "i-text") {
            const newWidthPx = cmToPixel(parseFloat(textWidthInput.value));
            const scaleFactorX = newWidthPx / activeObj.width;
            activeObj.scaleX = scaleFactorX;
            scaleXdata = "";
            canvas.fire('object:scaling', { target: activeObj });
            canvas.renderAll();
            updateTextInputs(activeObj);
        }
    });

    // Event listener for height input
    textHeightInput.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
        if (parseFloat(textHeightInput.value) > 100) {
            textHeightInput.value = 100;
        }
        if (activeObj && activeObj.type == "i-text") {            
            const newHeightPx = cmToPixel(textHeightInput.value);
            const scaleFactorY = newHeightPx / activeObj.height;
            activeObj.scaleY = scaleFactorY;
            scaleYdata = "";
            canvas.fire('object:scaling', { target: activeObj });
            canvas.renderAll();
            updateTextInputs(activeObj);
        }
    });

    // Add event listener for the slider
    imageScaleSlider.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
        if (activeObj && activeObj.type == "image") {
            // Get the current value of the slider
            const currentSliderValue = imageScaleSlider.value;

            // Compare current value with the previous value
            if (currentSliderValue > previousSliderValue) {
                // Call increaseObjectSize function
                increaseObjectSize(activeObj);
            } else if (currentSliderValue < previousSliderValue) {
                // Call decreaseObjectSize function
                decreaseObjectSize(activeObj);
            }

            // Update the previous value to the current value
            previousSliderValue = currentSliderValue;
        }
    });


    function increaseObjectSize() {
        const activeObj = canvas.getActiveObject(),
        newScaleX = ((activeObj?.scaleX) + (activeObj?.scaleX/30)),
        newScaleY = ((activeObj?.scaleY) + (activeObj?.scaleY/30));
        activeObj.scaleX = newScaleX;
        activeObj.scaleY = newScaleY;
        canvas.fire('object:scaling', { target: activeObj });
        canvas.renderAll();
    }

    function decreaseObjectSize() {
        // const canvas = window.__canvas;
        const activeObj = canvas.getActiveObject(),
        newScaleX = ((activeObj?.scaleX) - (activeObj?.scaleX/30)),
        newScaleY = ((activeObj?.scaleY) - (activeObj?.scaleY/30));
        activeObj.scaleX = newScaleX;
        activeObj.scaleY = newScaleY;
        canvas.fire('object:scaling', { target: activeObj });
        canvas.renderAll();
    }


    /* KP - Image resize slider */
    /*imageScaleSlider.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
      
        if (activeObj && activeObj.type === "image") {
            // Get the slider value and normalize it
            const scaleFactor = imageScaleSlider.value / 100;
            console.log(scaleFactor);
            // Apply the scale while ensuring it stays within limits
            resizeObject(activeObj, scaleFactor);
           // console.log(imageScaleSlider.value);
            //console.log(scaleFactor);
            // updateInputs(activeObj);
        }
    });

    function resizeObject(object, scaleFactor) {
        // Limit scaleFactor to a minimum and maximum
        const minScale = 0.1; // Minimum scale (10%)
        const maxScale = 3;   // Maximum scale (300%)

        const newScale = Math.min(Math.max(scaleFactor, minScale), maxScale);
        console.log("scaleFactor"+scaleFactor);
        object.scaleX = newScale;
        object.scaleY = newScale;

        console.log("newScale"+newScale);
        console.log("object.scaleX"+object.scaleX);
        console.log("object.scaleY"+object.scaleY);
        // Notify canvas and re-render
        canvas.fire('object:scaling', { target: object });
        canvas.renderAll();
    }*/
    /* KP - Image resize slider */

    // Event listener for width input
    imageWidthInput.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
        if (parseFloat(imageWidthInput.value) > 100) {
            imageWidthInput.value = 100;
        }
        if (activeObj && activeObj.type == "image") {            
            const newWidthPx = cmToPixel(parseFloat(imageWidthInput.value));
            const scaleFactorX = newWidthPx / originalWidth;
            activeObj.scaleX = scaleFactorX;
            scaleXdata = "";
            canvas.fire('object:scaling', { target: activeObj });
            canvas.renderAll();
            updateInputs(activeObj);
        }
    });

    // Event listener for height input
    imageHeightInput.addEventListener('input', function () {
        const activeObj = canvas.getActiveObject();
        if (parseFloat(imageHeightInput.value) > 100) {
            imageHeightInput.value = 100;
        }
        if (activeObj && activeObj.type == "image") {            
            const newHeightPx = cmToPixel(imageHeightInput.value);
            const scaleFactorY = newHeightPx / originalHeight;
            activeObj.scaleY = scaleFactorY;
            scaleYdata = "";
            canvas.fire('object:scaling', { target: activeObj });
            canvas.renderAll();
            updateInputs(activeObj);
        }
    });

    /* Image scaling background js */
    const sliderEl = document.getElementById('imagescale');
    sliderEl.addEventListener("input", (event) => {
        const tempSliderValue = event.target.value;

        const progress = (tempSliderValue / sliderEl.max) * 100;

        sliderEl.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${progress}%, #ccc ${progress}%)`;
    });
    sliderEl.dispatchEvent(new Event('input'));

    /* Image scaling background js */
    const sliderElTextSize = document.getElementById('textSizeInput');
    sliderElTextSize.addEventListener("input", (event) => {
        const tempSliderValue = event.target.value;

        const progress = (tempSliderValue / sliderElTextSize.max) * 100;

        sliderElTextSize.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${progress}%, #ccc ${progress}%)`;
    });
    sliderElTextSize.dispatchEvent(new Event('input'));

    /* KP - hide control while typing text functionality*/
    // KP - Debounce function to delay showing controls while typing text
    let typingTimeout;
    function debounce(func, delay) {
      clearTimeout(typingTimeout);
      typingTimeout = setTimeout(func, delay);
    }
    // KP - Debounce function to delay showing controls while typing text
    /* KP - hide control while typing text functionality*/

   // $("#bg_canvas_texttransform").on('change keyup paste', function (d) { // 
    document.getElementById('bg_canvas_texttransform').addEventListener('input', function(e) {
        var transformText = jQuery(this).val();
        if (transformText != "" && transformText.trim() != "") {
            var activeObject = canvas.getActiveObject();
            if (activeObject) {
                if (activeObject.type === 'i-text') {
                   /* KP - hide control while typing text functionality*/
                   // KP - Hide controls and borders
                    canvas.getActiveObject().set({
                        hasControls: false,
                        hasBorders: false,
                    });
                    canvas.renderAll();
                    /* KP - hide control while typing text functionality*/
                    
                    const wrappedText = wrapCanvasText(transformText, canvas, canvas.getActiveObject());
                    canvas.getActiveObject().set("text", wrappedText);
                    canvas.renderAll();
                    updateTextInputs(canvas.getActiveObject());

                } else {
                    addText(transformText);
                }
            } else {
                addText(transformText);
            }
        } else {
            let acObj = canvas.getActiveObject();
            if (acObj && acObj.type === 'i-text') {
                canvas.remove(acObj);
            }
        }
    });

    function addText(transformText) {
        const canvasHeight = canvas.getHeight() / canvas.viewportTransform[3];
        const additionalValue = (canvasHeight / 6); // Adjust this value as needed
        /*KP - Mobile screen masurement text display in position */
        const isMobile = window.innerWidth <= 767;
        /*KP - Mobile screen masurement text display in position */
        // Create the text object
        const text = new fabric.IText(transformText, {
            left: isMobile ? 900 : 400, /*KP - Mobile screen masurement text display in position */
            fontFamily: fontFamilySelect.value,
            fontSize: parseInt(textSizeInput.value),
            fill: textColorInput.value,
            fontWeight: boldCheckbox.checked ? 'bold' : 'normal',
            fontStyle: italicCheckbox.checked ? 'italic' : 'normal',
            underline: underlineCheckbox.checked,
            selectable: true,
            splitByGrapheme: true,
        });

        // Calculate the new top position
        let totalTextHeight = 0;
        canvas.forEachObject(obj => {
            if (obj.type === 'i-text') {
                const objHeight = obj.getScaledHeight(); // Get the scaled height of the text
                totalTextHeight += objHeight;
                if(((canvasHeight / 2) + additionalValue + totalTextHeight) > canvasHeight) {
                    totalTextHeight = objHeight;
                }
            }
        });

        let newTop = (canvasHeight / 2) + additionalValue + totalTextHeight;
        
        // Add the text to the canvas
        canvas.add(text);

        // Calculate the height of the newly added text
        const textHeight = text.getScaledHeight();

        // Check if the new total height exceeds the canvas height
        if (newTop + textHeight > canvasHeight) {
            // If it exceeds, reset totalTextHeight to the height of the new text only
            totalTextHeight = textHeight; // Only keep the new text height
            newTop = (canvasHeight / 2) + additionalValue; // Reset to default top position
        } else {
            // Otherwise, update totalTextHeight with the height of the newly added text
            totalTextHeight += textHeight;
        }

        // Set the top position for the text
        text.set('top', newTop);

        // Wrap text and update inputs
        const wrappedText = wrapCanvasText(transformText, canvas, text);
        text.set("text", wrappedText);

        canvas.setActiveObject(text);
        updateTextInputs(text);
        canvas.renderAll();
    }

    function wrapCanvasText(text, canvas, textObject) {
        const context = canvas.getContext("2d");

        // Use the font settings to match the text object
        context.font = `${textObject.fontSize}px ${textObject.fontFamily}`;

        let formatted = '';
        let line = '';

        for (let i = 0; i < text.length; i++) {
            line += text[i];
            const lineWidth = (context.measureText(line).width + textObject.left) * textObject.scaleX;
            if (pixelsToCentimeters(lineWidth) >= 90) {
                // If the current line exceeds the max width, add the line to formatted text
                formatted += line.slice(0, -1) + '\n'; // Add hyphen for broken word
                line = text[i]; // Start a new line with the current character
            }
        }

        // Add any remaining characters
        formatted += line;

        return formatted.trim();
    }

    document.getElementById('deactivateButton').addEventListener('click', function () {
        var activeObject = canvas.getActiveObject();

        if (activeObject && activeObject.type == "i-text") {
            $('#bg_canvas_texttransform').val("");
            resetTextData();
            canvas.discardActiveObject();
            canvas.renderAll();
        }
    });

    function resetTextData() {
        // Update input controls with the selected textbox properties
        fontFamilySelect.value = "Abril Fatface";
        textSizeInput.value = parseInt(textFontSize);
        let progress = (textScaleSlider.value / textScaleSlider.max) * 100;
        textScaleSlider.style.background = `linear-gradient(to right, rgb(8, 195, 128) ${progress}%, #ccc ${progress}%)`;
        textColorInput.value = "#000000";
        $('.bgColorPicker-container .clr-field').css('color', "#000000");
        boldCheckbox.checked = false;
        italicCheckbox.checked = false;
        underlineCheckbox.checked = false;
    }

  selectBtn.addEventListener("click", () =>
      optionMenu.classList.toggle("active")
    );

    // KP - Close dropdown when clicking outside Start
    document.addEventListener("click", (event) => {
        if (!optionMenu.contains(event.target) && !selectBtn.contains(event.target)) {
            optionMenu.classList.remove("active");
        }
    });
    // KP - Close dropdown when clicking outside end

    options.forEach((option) => {
      option.addEventListener("click", () => {
        let selectedOption = option.querySelector(".option-text").innerText;
        sBtn_text.innerText = selectedOption;

        let fontFamily = window.getComputedStyle(option.querySelector(".option-text")).fontFamily;
        // sBtn_text.style.fontFamily = fontFamily;
    
        let event = new Event("change");
        fontFamilySelect.value = option.querySelector(".option-text").getAttribute("value");            
        fontFamilySelect.dispatchEvent(event);

        optionMenu.classList.remove("active");
      });
    });


})(jQuery);